import { baseConf } from '@config/base'
import type { Config } from '@config/prod'

export const conf: Config = {
  ...baseConf,
  api: {
    auth: 'https://auth.qagr.io/v3',
    signin: 'https://qa-sh.io/auth/signin',
    signup: 'https://qa-sh.io/auth/signup',
  },
  domains: {
    cookie: '.qa-sh.io',
    controlPlaneCookie: '.qagr.io',
    main: 'qa-sh.io',
    grammarly: 'qagr.io',
    coda: 'head.coda.io',
  },
  sessionTransfer: {
    toCoda: 'https://head.coda.io/v1/mediator/initiate',
    toGrammarly: 'https://auth.qagr.io/v1/mediator/initiate',
  },
  tracking: {
    ...baseConf.tracking,
    gnar: {
      // TODO (tusharc): change back to gnar.qagr.io before going live
      // Refer https://grammarly.slack.com/archives/C02270EFMA9/p1758645743671299?thread_ts=1758639264.679989&cid=C02270EFMA9
      // gnar.qagr and gnar.ppgr not supported right now
      // we need to send all events to gnar.grammarly.com
      url: 'https://gnar.grammarly.com',
    },
  },
}
